import { isAuthenticated } from '../common/permissions';
import NotificationsPage from './NotificationsPage';

export default [
  {
    exact: true,
    path: '/notifications',
    helpId: 'notifications_list',
    permissions: [isAuthenticated],
    component: NotificationsPage,
  },
];
